import { IDatability } from '@metservicedev/platforms-services-interface/src/model/Widgetblock';
import React, { useState } from 'react';
import { useMDSContext } from '@metservice/use-mds';
import { Modal, Select } from 'antd';

// import { Select } from '../WidgetConfiguratorComponents/FormGroups';
import { QuestionOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface FlipDirectionProps {
    datability: IDatability;
    onUpdateDirection(direction: 'from' | 'to'): void;
    direction?: 'from' | 'to';
    disabled?: boolean;
    hoverText?: JSX.Element;
}
const FlipDirection = ({ datability, onUpdateDirection, direction, disabled, hoverText }: FlipDirectionProps) => {
    const { capabilities } = useMDSContext();
    const capability = capabilities.find(({ id }) => id === datability.capabilityId);
    const variables = Object.keys(capability?.variables || {});
    const variable = capability?.variables[variables[0]];
    const directionFromVariable = variable?.attributes?.direction;

    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <div style={{ gridColumn: '1 / auto' }}>
                <strong>Reference Direction:</strong>
                {hoverText && (
                    <Button
                        style={{ color: 'white', marginLeft: 2 }}
                        size='small'
                        icon={<QuestionOutlined style={{ color: 'rgba(0,0,0,.85)' }} />}
                        onClick={() => setShowModal(!showModal)}
                        shape='circle'
                    />
                )}
                {showModal && (
                    <Modal
                        title='Reference Direction'
                        visible={showModal}
                        onOk={() => setShowModal(false)}
                        onCancel={() => setShowModal(false)}
                        footer={[
                            <Button key='back' onClick={() => setShowModal(false)}>
                                Close
                            </Button>,
                        ]}
                    >
                        {hoverText}
                    </Modal>
                )}
            </div>
            <div style={{ gridColumn: '2 / 6' }}>
                <Select value={direction ?? directionFromVariable} onChange={onUpdateDirection} disabled={disabled} style={{ width: '100%' }}>
                    <Select.Option value='from'>{`From${directionFromVariable === 'from' ? ' (default)' : ''}`}</Select.Option>
                    <Select.Option value='to'>{`To${directionFromVariable === 'to' ? ' (default)' : ''}`}</Select.Option>
                </Select>
            </div>
        </>
    );
};

export default FlipDirection;
